<template>
    <div>
        <div class="overflow-auto">
            <div id="table-container">
                <ts-table :columns="columns" :records="model.student_attendance_list" :loading="loading">
                    <template slot-scope="{ record }">
                        <td>{{ record.student_name_en }}</td>
                        <td class="ts-whitespace-no-wrap">
                            <div class="radio radio-css radio-inline" v-for="status in attendanceKeys" :key="status">
                                <input type="radio" :id="`${status}-${record.student_id}`"
                                    :name="`attendance-${record.student_id}`" :value="1" v-model="record[status]"
                                    @change="onStatusChange(record, status)" />
                                <label :for="`${status}-${record.student_id}`">
                                    {{ status.charAt(0).toUpperCase() + status.slice(1) }}
                                </label>
                            </div>
                        </td>
                        <td class="ts-whitespace-no-wrap">
                            <input type="text" v-model="record.comments" class="form-control only-border-bottom" />
                        </td>
                    </template>
                </ts-table>
            </div>
        </div>
        <hr />
        <ts-card-wrapper>
            <div class="text-right">
                <ts-button @click.prevent="save" color="primary" :disabled="model.student_attendance_list.length <= 0"
                    :waiting="saving">{{ $t('save') }}</ts-button>
            </div>
        </ts-card-wrapper>
    </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
export default {
    name: 'studentAttendance',
    props: ['model'],
    data() {
        return {
            loading: false,
            errors: new Errors(),
            saving: false,
            attendanceKeys: ['present', 'absent', 'permission', 'late']
        }
    },
    computed: {
        columns() {
            return [
                { name: this.$t('classAttendance.studentName'), style: 'width: 20%' },
                { name: this.$t('classAttendance.attendanceStatus') },
                { name: this.$t('classAttendance.comments'), style: 'width: 30%' }
            ]
        }
    },
    methods: {
        async save() {
            this.errors = new Errors()
            this.saving = true

            const payload = { ...this.model }

            if (payload.att_date) {
                payload.att_date = moment(payload.att_date, 'DD-MM-YYYY').format(
                    'YYYY-MM-DD'
                )
            }
       try {
            let response = await this.$store.dispatch(
                'classAttendanceV2/store',
                payload
            )
            this.$toasted.success(response.data.message)
            this.$emit('saved')
        } catch (error) {
            const data = error.response && error.response.data ? error.response.data : {}
            this.$toasted.error(data.message || (data.errors && Object.values(data.errors)[0][0]) || error.message)
            if (data.errors) {
                this.errors = new Errors(data.errors)
            }
        }

            this.saving = false
        },
        onStatusChange(record, selectedStatus) {
            // Reset all statuses to 0 first
            this.attendanceKeys.forEach(key => {
                record[key] = 0
            })
            // Set the selected status to 1
            record[selectedStatus] = 1
        }
    }
}
</script>

<style lang="scss" scoped>
#table-container {
    min-height: 30vh;
    max-height: 50vh;
    overflow-y: scroll;
}

.table>thead>tr>th {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 999;
}

.table>tbody>tr>td {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    border: none !important;
}

.only-border-bottom {
    border-top: none;
    border-left: none;
    border-right: none;
}

::-webkit-scrollbar {
    height: 8px;
    width: 3px;
    /* Remove scrollbar space */
    background: #ffff;
    /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
    background: #b7b7b8;
}

hr {
    border: 1px solid #ececec;
}
</style>
